import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UtilService, VariablesService } from '../../shared/services';

@Component({
  selector: 'app-rewards-and-benefits',
  templateUrl: './rewards-and-benefits.component.html',
  styleUrls: ['./rewards-and-benefits.component.scss']
})
export class RewardsAndBenefitsComponent implements OnInit {

  @Output() public text = new EventEmitter<any>();

  benefits = [{ img: '/assets/images/benefits_1.png', title: 'SIP Protect', text: 'Win back the money you donate through SIP' }, { img: '/assets/images/benefits_2.png', title: 'Medical Bill Reimbursement', text: 'Emergency medical bills? Simply upload it and let Ketto cover that extra expense.' }, { img: '/assets/images/benefits_3.png', title: 'Matching Donation', text: 'Ketto will donate as much as you to double your impact' }];
  rewards = [{ img: '/assets/images/rewards_logo_1.png' }, { img: '/assets/images/rewards_logo_2.png' }, { img: '/assets/images/rewards_logo_3.png' }, { img: '/assets/images/rewards_logo_4.png' }, { img: '/assets/images/rewards_logo_5.png' },
  { img: '/assets/images/rewards_logo_6.png' }, { img: '/assets/images/rewards_logo_7.png' }, { img: '/assets/images/rewards_logo_8.png' }, { img: '/assets/images/rewards_logo_9.png' }, { img: '/assets/images/rewards_logo_10.png' }];
  isMobile;

  constructor(
    public utilService: UtilService,
    public vars: VariablesService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.isMobile = this.utilService?.isMobile();
  }

  claimrewards() {
    this.vars.event_info.info_1 = 'Benefits_&_Rewards';
    this.utilService.scrollIntoViewSmoothly('donation-form', 30);
    this.utilService.router.navigate([], { queryParams: { rewards: '1' }, queryParamsHandling: 'merge' });
    this.text.emit(false);
  }

  opendialog(template) {
    this.dialog.open(template, {
      width: this.utilService.isMobile() ? '100vw' : '736px',
      maxWidth: '100%',
      panelClass: 'popup',
      closeOnNavigation: false,
      disableClose: true
    });
  }

  close() {
    this.dialog.closeAll();
  }
}
